export const arePersonalInfoModified = (personalInfo, initialValues) =>
  !(
    personalInfo.gender === initialValues.gender &&
    personalInfo.givenName === initialValues.givenName &&
    personalInfo.familyName === initialValues.familyName &&
    personalInfo.identification.identificationId === initialValues.identification.identificationId &&
    personalInfo.nationality === initialValues.nationality &&
    personalInfo.identificationType === initialValues.identificationType &&
    personalInfo.birthdate === initialValues.birthdate
  );
